// The station archive uses Europe/Rome civil time unless an explicit offset is supplied.
const clock = new Intl.DateTimeFormat('sv-SE', {timeZone:'Europe/Rome',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
function wallClock(ms) {
 const p=Object.fromEntries(clock.formatToParts(ms).map(v=>[v.type,v.value]));
 return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}:${p.second}`;
}
export function stationArchiveTime(value) {
 if(typeof value!=='string'||!value.trim())return null;
 const raw=value.trim().replace(' ','T');
 if(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(raw)){const ms=Date.parse(raw);return Number.isFinite(ms)?ms:null;}
 const m=raw.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})(?::(\d{2})(?:\.\d+)?)?$/);
 if(!m)return null;
 const text=m[1]+':'+(m[2]||'00'),wall=Date.parse(text+'Z');
 if(!Number.isFinite(wall))return null;
 // Both modern Rome offsets are checked, including the DST transition days.
 // The repeated autumn hour lacks an offset in the source: prefer standard time.
 for(const offset of [60,120]){const ms=wall-offset*60000;if(wallClock(ms)===text)return ms;}
 return null;
}
export function station24HourSeries(points,keys,parametro,now=Date.now()) {
 const start=now-86400000,byTime=new Map();
 for(const p of Array.isArray(points)?points:[]) {
  const x=stationArchiveTime(p.observed_at||p.data_rilevazione||p.timestamp);
  if(x===null||x<start||x>now)continue;
  let y=null;
  for(const key of keys){const v=p[key];if(v!==null&&v!==undefined&&v!==''&&Number.isFinite(Number(v))&&Number(v)>-99.9){y=Number(v);break;}}
  byTime.set(x,{x,y});
 }
 const rows=[...byTime.values()].sort((a,b)=>a.x-b.x),series=[];
 const intervals=rows.slice(1).map((row,i)=>row.x-rows[i].x).sort((a,b)=>a-b);
 // Hourly SYNOP/METAR observations have a different normal cadence from 1-minute stations.
 const cadence=intervals[Math.floor(intervals.length/2)]||0;
 const gapLimit=Math.max(30*60000,Math.min(90*60000,3*cadence));
 for(let i=0;i<rows.length;i++) {
  const row=rows[i],prev=rows[i-1];
  if(prev&&(row.x-prev.x>gapLimit||(parametro==='rain'&&wallClock(prev.x).slice(0,10)!==wallClock(row.x).slice(0,10))))series.push({x:row.x-1,y:null});
  series.push(row);
 }
 return series;
}
